import swal from "sweetalert";

export default (callback) => {
  swal({
    icon: "error",
    type: "error",
    title: "Your Session Expired! Please Login Again!!",
  }).then(callback);
};
